import { Error as ErrorScreen } from '../screens/error';
import { success, notFound } from '../util/Response';
import {
    SITEMAP_SCREEN,
    TERMS_SCREEN,
    ERROR_SCREEN,
    PRIVACY_SCREEN
} from './types';

const defaultFetchData = () => Promise.resolve(success({}));
const notFoundFetchData = () => Promise.resolve(notFound);

const notFoundRoute = {
    path: '/(.*)',
    action: () => ({
        fetchData: notFoundFetchData,
        Screen: ErrorScreen,
        screenName: ERROR_SCREEN
    })
};

const routes = {
    path: '/',
    children: [
        {
            path: '/sitemap/',
            action: (context) =>
                import(
                    /* webpackChunkName: "SitemapAsync" */ '../screens/sitemap'
                ).then(({ fetchData, Sitemap }) => ({
                    fetchData: () => fetchData(context),
                    Screen: Sitemap,
                    screenName: SITEMAP_SCREEN
                })),
            children: []
        },
        {
            path: '/terms/',
            action: (context) =>
                import(
                    /* webpackChunkName: "TermsAsync" */ '../screens/terms'
                ).then(({ Terms }) => ({
                    fetchData: () => defaultFetchData(),
                    Screen: Terms,
                    screenName: TERMS_SCREEN
                })),
            children: []
        },
        {
            path: '/privacy/',
            action: (context) =>
                import(
                    /* webpackChunkName: "PrivacyAsync" */ '../screens/privacy'
                ).then(({ Privacy }) => ({
                    fetchData: () => defaultFetchData(),
                    Screen: Privacy,
                    screenName: PRIVACY_SCREEN
                })),
            children: []
        },
        notFoundRoute
    ]
};

export default routes;
